export const DEFAULT_TEXTS = {
  "nav.problem": "Le problème",
  "nav.solution": "La solution",
  "nav.offer": "L'offre fondateur",
  "nav.faq": "FAQ",
  "nav.login": "Se connecter",
  "nav.cta": "Devenir club fondateur",
  "hero.badge": "Pour les clubs sportifs amateurs",
  "hero.title": "Gardez vos sponsors, saison après saison",
  "hero.subtitle": "L'outil simple pour suivre vos partenaires, leurs contreparties et leur envoyer un bilan qui donne envie de renouveler.",
  "hero.cta": "Devenir club fondateur",
  "hero.login": "Se connecter",
  "shot.caption": "Exemple avec un club fictif",
  "problem.eyebrow": "Le problème",
  "problem.title": "Un sponsor qui ne renouvelle pas, c'est souvent un sponsor qu'on a oublié.",
  "problem.1.title": "Des contreparties oubliées",
  "problem.1.text": "Le panneau jamais réinstallé, la publication promise qui n'est jamais partie : le sponsor, lui, s'en souvient.",
  "problem.2.title": "Des relances ratées",
  "problem.2.text": "Les échéances sont dans la tête d'un bénévole ou au fond d'un tableur. La fin de contrat arrive sans prévenir.",
  "problem.3.title": "Rien à montrer au moment du renouvellement",
  "problem.3.text": "Sans chiffres ni photos, difficile de prouver ce que le club a apporté, et de défendre le montant.",
  "solution.eyebrow": "La solution",
  "solution.title": "Tout le suivi de vos partenaires, au même endroit.",
  "solution.1.title": "Le tableau de bord",
  "solution.1.text": "Sponsors actifs, montants encaissés, contreparties livrées et renouvellements à venir : tout ce qui compte, en un coup d'œil.",
  "solution.2.title": "La fiche sponsor",
  "solution.2.text": "Chaque contrepartie se coche « Livré » en un clic, les retards ressortent en orange et les rappels vous préviennent à temps.",
  "solution.3.title": "Le bilan de visibilité",
  "solution.3.text": "Un bilan propre, à envoyer par email ou en PDF, qui montre au sponsor tout ce que le club a fait pour lui.",
  "offer.eyebrow": "L'offre fondateur",
  "offer.title": "Rejoignez les premiers clubs Partenia.",
  "offer.text": "Les clubs fondateurs profitent d'un tarif réservé et d'un accompagnement personnel pour démarrer la saison sereinement.",
  "offer.period": "la première année · TVA non applicable, art. 293 B du CGI",
  "offer.item1": "{prix_fondateur} la première année au lieu de {prix_normal}",
  "offer.item2": "Mise en place faite pour vous",
  "offer.item3": "Remboursé si l'outil n'est pas livré le {date_livraison} ou si vous n'êtes pas satisfait après 30 jours",
  "offer.item4": "{places} places seulement",
  "offer.reserve": "Réserver ma place",
  "offer.full": "Complet · être prévenu de la suite",
  "offer.member": "Devenir membre",
  "offer.transfer": "Payer par virement sur facture",
  "offer.secure": "Paiement sécurisé · remboursement garanti",
  "offer.question": "Une question avant de réserver ?",
  "offer.callback": "Être rappelé",
  "about.eyebrow": "Qui suis-je",
  "about.name": "Hugo Veller",
  "about.role": "Ancien chargé de sponsoring au Golf de la Baie de Morlaix",
  "about.bio": "Pendant mes années au Golf de la Baie de Morlaix, j'ai suivi les partenaires avec des tableurs, des post-it et beaucoup de mémoire. J'ai vu ce qui fait qu'un sponsor renouvelle : des promesses tenues, et quelqu'un qui le lui montre. J'ai créé Partenia pour que chaque club puisse le faire simplement, sans y passer ses soirées.",
  "about.cta": "Prendre 15 minutes pour en parler",
  "callback.eyebrow": "Être rappelé",
  "callback.title": "Pas encore décidé ? Hugo vous rappelle.",
  "callback.text": "Laissez vos coordonnées : un appel de quelques minutes pour voir si Partenia convient à votre club, sans engagement.",
  "callback.form.name": "Votre nom",
  "callback.form.club": "Nom du club",
  "callback.form.phone": "Téléphone",
  "callback.form.slot": "Créneau préféré",
  "callback.form.consent": "J'accepte que Partenia utilise ces informations pour me rappeler au sujet de l'offre. Elles ne sont ni revendues ni utilisées à d'autres fins.",
  "callback.form.submit": "Être rappelé",
  "callback.success.title": "Merci, c'est noté.",
  "callback.success.text": "Hugo vous rappelle rapidement, si possible sur le créneau indiqué.",
  "faq.eyebrow": "FAQ",
  "faq.title": "Vos questions",
  "faq.1.q": "Est-ce que c'est compliqué à prendre en main ?",
  "faq.1.a": "Non. Partenia a été pensé pour des bénévoles pressés : trois écrans, aucun jargon, et tout fonctionne sur téléphone. Pour les clubs fondateurs, la mise en place est faite pour vous : vos sponsors et leurs contreparties sont saisis avant votre première connexion.",
  "faq.2.q": "Mes données sont-elles sécurisées ?",
  "faq.2.a": "Oui. Chaque club dispose d'un espace privé : personne d'autre ne voit vos sponsors. Les mots de passe sont chiffrés, les échanges passent en HTTPS, et vos données ne sont ni revendues ni utilisées à des fins publicitaires.",
  "faq.3.q": "Et si ça ne me convient pas ?",
  "faq.3.a": "Vous êtes remboursé. Si l'outil n'est pas livré le {date_livraison}, ou si vous n'êtes pas satisfait après 30 jours d'utilisation, il suffit de nous écrire pour être remboursé intégralement.",
  "footer.legal": "Mentions légales",
  "footer.privacy": "Politique de confidentialité",
  "footer.contact": "Contact",
};
